/**
 * ReceiptProfiles — desktop port of BigxBookApp/src/printing/engine/ReceiptProfiles.ts,
 * extended with a 112mm profile for wide POS printers.
 *
 * charsPerLine is Font A (12 dots wide) across the printable area:
 *   58mm  → ~48mm printable → 32 chars
 *   80mm  → ~72mm printable → 48 chars
 *   112mm → ~104mm printable → 64 chars
 */

import { ReceiptProfile } from '../contracts/ReceiptContracts';
import { PaperWidth } from '../contracts/PrintTypes';

export const RECEIPT_PROFILE_112MM: ReceiptProfile = {
  paperWidth: 112,
  charsPerLine: 64,
};

export const RECEIPT_PROFILE_80MM: ReceiptProfile = {
  paperWidth: 80,
  charsPerLine: 48,
};

export const RECEIPT_PROFILE_58MM: ReceiptProfile = {
  paperWidth: 58,
  charsPerLine: 32,
};

/** Printable dots across the head, used to scale rasterised logos. */
export const PAPER_WIDTH_DOTS: Record<PaperWidth, number> = {
  58: 384,
  80: 576,
  112: 832,
};

export const getReceiptProfile = (paperWidth: PaperWidth): ReceiptProfile => {
  switch (paperWidth) {
    case 58:
      return RECEIPT_PROFILE_58MM;
    case 112:
      return RECEIPT_PROFILE_112MM;
    default:
      return RECEIPT_PROFILE_80MM;
  }
};
